var $1387676441be6cf6$exports = {};
$1387676441be6cf6$exports = {
  "buttonLabel": "Vis forslag",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " alternativ");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " alternativer");
      }
    }), " finnes.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Angitt gruppe ".concat(args.groupTitle, ", med ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " alternativ");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " alternativer");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valgt",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Forslag",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valgt");
  }
};
export { $1387676441be6cf6$exports as default };